module.exports = __webpack_public_path__ + "img/AT0000002686077.61d4b675.png";